var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "lc-pagination" }, [
    _c(
      "ul",
      { staticClass: "pagination" },
      [
        _c(
          "li",
          {
            class: [
              "page-item",
              "fixed",
              { disabled: _vm.paginator.currentPage == 1 },
            ],
          },
          [
            _c(
              "a",
              {
                staticClass: "page-link",
                on: {
                  click: function ($event) {
                    _vm.paginator.currentPage = _vm.paginator.currentPage - 1
                  },
                },
              },
              [_c("span", { staticClass: "mdi mdi-chevron-left" })]
            ),
          ]
        ),
        _vm._l(_vm.pageNumbers, function (pageNum, index) {
          return [
            _c(
              "li",
              {
                key: index,
                class: [
                  "page-item",
                  { active: _vm.paginator.currentPage == pageNum },
                ],
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "page-link",
                    class: { disabled: pageNum == "..." },
                    on: {
                      click: function ($event) {
                        _vm.paginator.currentPage = pageNum
                      },
                    },
                  },
                  [_vm._v(_vm._s(pageNum))]
                ),
              ]
            ),
          ]
        }),
        _c(
          "li",
          {
            class: [
              "page-item",
              "fixed",
              { disabled: _vm.paginator.currentPage == _vm.paginator.maxPage },
            ],
          },
          [
            _c(
              "a",
              {
                staticClass: "page-link",
                on: {
                  click: function ($event) {
                    _vm.paginator.currentPage = _vm.paginator.currentPage + 1
                  },
                },
              },
              [_c("span", { staticClass: "mdi mdi-chevron-right" })]
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }